import { ActivityTypesEnum } from "./ActivityTypesEnum";
import { IOptionItem } from "./option-item.interface";

export const ActivitySelectListContent : IOptionItem[] = [
    {
      id: ActivityTypesEnum.All,
      name: 'All Actions',
    },
    {
      id: ActivityTypesEnum.Dispensed,
      name: 'Dispensed',
    },
    {
      id: ActivityTypesEnum.Received,
      name: 'Received',
    },
    {
      id: ActivityTypesEnum.Amendment,
      name: 'Amended',
    },
    {
      id: ActivityTypesEnum.Audit,
      name: 'Audit',
    },
    {
      id: ActivityTypesEnum.DamagedExpired,
      name: 'Damaged / Expired',
    },
    {
      id: ActivityTypesEnum.LostStolen,
      name: 'Lost / Stolen',
    },
    {
      id: ActivityTypesEnum.MovedTo,
      name: 'Moved To',
    },
    {
      id: ActivityTypesEnum.MovedFrom,
      name: 'Moved From',
    },
    {
      id: ActivityTypesEnum.Returned,
      name: 'Returned to Wholesaler',
    },
    {
      id: ActivityTypesEnum.SoldToProvider,
      name: 'Sold to Provider',
    },
    {
      id: ActivityTypesEnum.SoldToReverseDistributor,
      name: 'Sold to Rev. Distr.',
    },
    {
      id: ActivityTypesEnum.WastedDestroyed,
      name: 'Wasted / Destroyed',
    },
    {
      id: ActivityTypesEnum.Mixed,
      name: 'Mixed',
    },
  ];